import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70bf3e7e")

_pushScopeId("data-v-70bf3e7e")
const _hoisted_1 = { class: "top-bar" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_login_and_out = _resolveComponent("login-and-out")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_login_and_out)
  ]))
})